import React, {useEffect, useState, useRef} from 'react';
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import {styled} from '@mui/system';
import Cookies from 'js-cookie';

const StyledDataGrid = styled(DataGrid)(({theme}) => ({
    '& .MuiDataGrid-row': {
        '&:nth-child(even)': {
            backgroundColor: '#eaf0f5',
        },
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
    },
    '& .negative.win_rate_per, .negative.revenue_per, .negative.fill_rate_per, .negative.profit_per': {
        backgroundColor: 'rgba(255,235,235)',
    },
    '& .positive.win_rate_per, .positive.revenue_per, .positive.fill_rate_per, .positive.profit_per': {
        backgroundColor: 'rgba(235,255,235)',
    },
    '& .MuiDataGrid-cell': {
        whiteSpace: 'normal !important',
        wordWrap: 'break-word',
    },
    '& .total-row': {
        backgroundColor: 'lightgrey',
        fontWeight: 'bold',
    },
    '& .MuiDataGrid-booleanCell[data-value="true"]': {
        color: 'rgb(58,187,58)',
    },
    '& .MuiDataGrid-booleanCell[data-value="false"]': {
        color: 'rgba(180,92,101,0.95)',
    },
}));

function processData(data) {
    if (!data || !Array.isArray(data) || data.length === 0) return [];
    return data.map(row => ({
        id: row.value.id,
        ...row.value,
    }));
}

const SuggestedBundlePanelGrid = ({data, onRowEdit}) => {
    const gridRef = useRef(null);
    const [rows, setRows] = useState(processData(data));
    const [open, setOpen] = useState(false);
    const [openSend, setOpenSend] = useState(false);
    const [editRow, setEditRow] = useState({});
    const [openDelete, setOpenDelete] = useState(false);

    const has = field => rows.some(row => field in row);

    useEffect(() => {
        setRows(processData(data));
    }, [data]);

    let columns = [];
    if (has('id')) columns.push({ field: 'id', headerName: 'ID', width: 80 });
    if (has('bundle')) columns.push({ field: 'bundle', headerName: 'Bundle', width: 200 });
    if (has('url')) columns.push({ field: 'url', headerName: 'URL', width: 300 });
    if (has('genre')) columns.push({ field: 'genre', headerName: 'Genre', width: 150 });
    if (has('app_name')) columns.push({ field: 'app_name', headerName: 'App Name', width: 200 });
    if (has('type')) columns.push({ field: 'type', headerName: 'Type', width: 100 });
    if (has('domain')) columns.push({ field: 'domain', headerName: 'Domain', width: 200 });
    if (has('revenue')) columns.push({
        field: 'revenue',
        headerName: 'Revenue',
        width: 150,
        type: 'number',
        align: 'right',
        headerAlign: 'right',
        valueFormatter: ({ value }) => {
            const n = Number(value);
            return Number.isFinite(n)
                ? n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })
                : '';
        },
    });
    if (has('requests')) columns.push({ field: 'requests', headerName: 'Requests', width: 150, type: 'number' });
    if (has('processed')) columns.push({ field: 'processed', headerName: 'Processed', width: 120, type: 'boolean', cellClassName: (params) => params.value ? 'boolean-true' : 'boolean-false', });
    if (has('suggested')) columns.push({ field: 'suggested', headerName: 'Suggested', width: 120, type: 'boolean' });
    if (has('used')) columns.push({ field: 'used', headerName: 'Used', width: 120, type: 'boolean' });
    if (has('irtb_company_id')) columns.push({ field: 'irtb_company_id', headerName: 'iRTB Company ID', width: 150 });
    if (has('adt_company_id')) columns.push({ field: 'adt_company_id', headerName: 'ADT Company ID', width: 150 });
    if (has('suggested_at')) columns.push({ field: 'suggested_at', headerName: 'Suggested At', width: 180 });
    if (has('used_at')) columns.push({ field: 'used_at', headerName: 'Used At', width: 180 });

    if (data.length === 0) {
        return null;
    } else {

        return (

            <div style={{height: 800, width: '100%'}} ref={gridRef}>
                <StyledDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={25}
                    slots={{
                        toolbar: GridToolbar,
                    }}
                    disableRowSelectionOnClick
                />
            </div>
        );
    }
};

export default SuggestedBundlePanelGrid;